module.exports = __webpack_public_path__ + "static/img/m_improvement_3.7d94151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m_improvement_3.png
// module id = e+6G
// module chunks = 1